import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { NomenclatureCategoryDto, NomenclatureDto, Paginated } from '@eombor/contracts';
import { catalogApi, type NomenclatureQuery } from '../api/catalog.api.js';

/**
 * Katalog so'rovlari bitta joyda: kalitlar ham shu yerda turadi, shuning uchun
 * `invalidateQueries({ queryKey: catalogKeys.all })` katalog sahifasida ham,
 * kirim ekranidagi nomenklatura tanlovida ham bir xil ishlaydi.
 */
export const catalogKeys = {
  all: ['catalog'] as const,
  list: (query: NomenclatureQuery) => ['catalog', 'nomenclatures', query] as const,
  categories: ['catalog', 'categories'] as const,
};

export const useNomenclatures = (
  query: NomenclatureQuery = {},
): UseQueryResult<Paginated<NomenclatureDto>> =>
  useQuery({
    queryKey: catalogKeys.list(query),
    queryFn: () => catalogApi.list(query),
  });

/**
 * Kategoriyalar kunda bir marta ham o'zgarmaydi, lekin ular filtrda ham,
 * dialogdagi tanlovda ham kerak — `staleTime` uzun bo'lsa ro'yxat bir marta
 * yuklanadi va ikkinchi joyda kutish bo'lmaydi.
 */
export const useCategories = (): UseQueryResult<Paginated<NomenclatureCategoryDto>> =>
  useQuery({
    queryKey: catalogKeys.categories,
    queryFn: () => catalogApi.listCategories({ limit: 200 }),
    staleTime: 300_000,
  });
